export const getters = {
  credentials: state => state.credentials
}

export default getters



// WEBPACK FOOTER //
// ./src/store/module/signIn/getters.js